export default __webpack_public_path__ + "static/media/img_ews_response-colorBkg.d7bf1625.png";